<template>
	<div class="icons">
		<ul class="icons-wrap">
			<li class="icon-item" v-for="(item, i) in icons" :key="i" @click="addMixpanel(item)">
				<a :href="item.link">
					<img class="icon-img" :src="item.icon" />
					<p class="icon-text" style="color: #141A42">
						<!--:style="{color: icons.length - 1 === i ? '#D0D1D9' : '#141A42'}"-->
						{{ item.name }}
					</p>
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
  import mixpanel from '@/utils/mixpanel.js'
  export default {
    name: "Icons",
    data() {
      return {
        icons: [
          {
            name: 'Job Board',
            icon: require('@/assets/icon/ic_job.svg'),
            link: `${process.env.VUE_APP_JOB_Link}/job-board?showJobV2=true`,
            mixParams: 'Job'
          }, {
            name: 'Truckloads',
            icon: require('@/assets/icon/ic_loads.svg'),
            link: 'truckerpath://trucker_loads',
            mixParams: 'Load Board'
          }, {
            name: 'Trucks & Trailers',
            icon: require('@/assets/icon/ic_find.svg'),
            link: 'https://truck.truckerpath.com/all?utm_source=trucker_path&utm_medium=service&utm_campaign=used_truck_201905&utm_content=L1_Service',
            mixParams: 'Trucks & Equipment'
          }, {
            name: 'ELD',
            icon: require('@/assets/icon/ic_eld.svg'),
            link: 'https://eld.truckerpath.com/landingpage/one?utm_source=trucker_path&utm_medium=side_menu_button_one',
            mixParams: 'Electronic Logging Device'
          }, {
            name: '24/7 Road Service',
            icon: require('@/assets/icon/ic_roadside.svg'),
            link: 'truckerpath://road_assistance',
            mixParams: 'Assistance'
          }, {
            name: 'Factoring',
            icon: require('@/assets/icon/ic_factoring.svg'),
            link: 'https://www.getinstapay.com/instapay-mobile-landing',
            mixParams: 'Factoring'
          }, {
            name: 'Earn Cash',
            icon: require('@/assets/icon/ic_earncash.svg'),
            link: 'https://backoffice-v2.truckerpath.com/landingpage?utm_source=trucker_path&utm_medium=service_icon&utm_term=Trucker-Path&utm_campaign=referral_program&utm_content=referral_bannerhttps://backoffice-v2.truckerpath.com/landingpage?utm_source=trucker_path&utm_medium=service_icon&utm_term=Trucker-Path&utm_campaign=referral_program&utm_content=referral_banner',
            mixParams: 'Earn Cash'
          }, {
            name: 'Coming Soon',
            icon: require('@/assets/icon/ic_somingsoon.svg'),
            link: 'javascript:void(0);',
            mixParams: null
          }
        ]
      }
    },
    methods: {
      addMixpanel(item) {
        if (item.mixParams) {
          mixpanel.track('Discover Page', {'Outcome': item.mixParams})
        }
      }
    },
  }
</script>

<style scoped>
@font-face {
	font-family: SFProText-Medium;
	src: url(../../assets/fonts/SF-Pro-Text-Medium.otf);
}

.icons {
	color: #141a42;
	font-family: SFProText-Medium;
}

.icons-wrap {
	overflow: hidden;
	padding-top: 20px;
}

.icon-item {
	width: 25%;
	height: 75px;
	text-align: center;
	float: left;
	margin-bottom: 20px;
	cursor: pointer;
}

.icon-img {
	width: 40px;
}

.icon-text {
	font-size: 13px;
	font-weight: 600;
	height: 30px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}
</style>
